var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "UiCard",
    {
      style: {
        "background-color": _vm.shift.active
          ? null
          : "var(--colors-gray-100) !important",
      },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-center mb-3" },
        [
          _c("div", { staticClass: "handle mr-2 px-1" }, [
            _c("i", {
              staticClass: "fa fa-arrows fa-fw mr-1",
              attrs: { "aria-hidden": "true" },
            }),
          ]),
          _vm._v(" "),
          _c("h3", {
            staticClass: "mb-0",
            domProps: { textContent: _vm._s(_vm.shift.name) },
          }),
          _vm._v(" "),
          _c("BFormCheckbox", {
            staticClass: "ml-auto",
            attrs: {
              name: "check-button",
              switch: "",
              "aria-label": _vm.$t("watches.active_shift"),
            },
            on: { change: _vm.handleActiveChange },
            model: {
              value: _vm.shift.active,
              callback: function ($$v) {
                _vm.$set(_vm.shift, "active", $$v)
              },
              expression: "shift.active",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            display: "flex",
            "flex-direction": "column",
            gap: ".33rem",
          },
          style: { opacity: _vm.shift.active ? 1 : 0.5 },
        },
        [
          _vm.shift.dates_active
            ? _c("div", { staticClass: "capitalize-first-letter" }, [
                _c("strong", [
                  _vm._v(_vm._s(_vm.dateFormatLong(_vm.shift.date_start))),
                ]),
                _vm._v(" →\n      "),
                _c("strong", [
                  _vm._v(_vm._s(_vm.dateFormatLong(_vm.shift.date_end))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shift.days.length > 0 && _vm.shift.days.length < 7
            ? _c(
                "div",
                [
                  _c("i", {
                    staticClass: "fa fa-calendar fa-fw mr-1",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.daysSorted, function (day) {
                    return _c(
                      "span",
                      [
                        _vm._v("\n        " + _vm._s(_vm.dayName(day))),
                        day !== _vm.shift.days[_vm.shift.days.length - 1]
                          ? [_vm._v(", ")]
                          : _vm._e(),
                      ],
                      2
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.shift.days.length === 7
            ? _c("div", [
                _c("i", {
                  staticClass: "fa fa-calendar fa-fw mr-1",
                  attrs: { "aria-hidden": "true" },
                }),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("watches.every_day")))]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shift.days.length === 0
            ? _c("div", [
                _c("span", { staticClass: "text-danger" }, [
                  _c("i", {
                    staticClass: "fa fa-calendar fa-fw mr-1",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(_vm._s(_vm.$t("watches.no_days"))),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", [
            _c("i", {
              staticClass: "fa fa-clock-o fa-fw mr-1",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.timeFormatHourMin(_vm.shift.time_start))),
            ]),
            _vm._v(" →\n      "),
            _c("span", [
              _vm._v(_vm._s(_vm.timeFormatHourMin(_vm.shift.time_end))),
            ]),
            _vm._v("\n      (" + _vm._s(_vm.timeDifference) + ")\n    "),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("i", {
              staticClass: "fa fa-user-circle-o fa-fw mr-1",
              class: _vm.watchColorClass(_vm.watchRules.status),
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" "),
            _vm.watchRules.watchmen.length > 0
              ? _c(
                  "span",
                  [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.watchRules.watchmen.length) + " :"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.watchRules.watchmen, function (watchman) {
                      return _c(
                        "span",
                        { key: watchman.id },
                        [
                          _c("span", { staticClass: "d-inline-block px-1" }, [
                            _vm._v(_vm._s(watchman.name)),
                          ]),
                          watchman !==
                          _vm.watchRules.watchmen[
                            _vm.watchRules.watchmen.length - 1
                          ]
                            ? [_vm._v(" • ")]
                            : _vm._e(),
                        ],
                        2
                      )
                    }),
                  ],
                  2
                )
              : _c("span", { staticClass: "text-danger" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("watches.no_watchmen")) +
                      "\n      "
                  ),
                ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex" },
        [
          _c(
            "Button2",
            {
              staticClass: "btn-sm ml-auto",
              nativeOn: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.handleEditShift()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("global.edit")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }